__turbopack_context__.v({
  "className": "Pya6zq_className",
  "variable": "Pya6zq_variable",
});
